import React from "react";
import { amountLimit, approvalAmount, currentMilga, enteredAmount, foodChain, details, sumAmount } from "../texts/fill";
import Detail from "../common/detail";
import NumberDetail from "../common/number_detail";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { return_choose } from "../texts/login";
import "./UserDetails.css";

const UserDetails = ({ showButton = true, user }) => {
    const navigate = useNavigate();
    const partnerships = useSelector((state) => state.partnerships);

    return (
        <div className="user-details">
            <div className="title">
                <h3>{showButton ? details : user?.currentMilga}</h3>
                {showButton && partnerships && (
                    <button className="btn btn-primary" onClick={() => navigate("/choose")}>
                        {return_choose}
                    </button>
                )}
            </div>
            <hr />
            <h4>{user?.name}</h4>
            <h5>{user?.area}</h5>
            <Detail label={currentMilga} text={user?.currentMilga} />
            {user?.foodChain && <Detail label={foodChain} text={user.foodChain} />}
            {user?.amountLimitForEach && <NumberDetail label={amountLimit} text={user.amountLimitForEach} />}
            <NumberDetail label={approvalAmount} text={user?.approvalAmount} />
            <NumberDetail label={enteredAmount} text={user?.enteredAmount} />
            <NumberDetail label={sumAmount} text={(user?.approvalAmount || 0) - (user?.enteredAmount || 0)} border />
        </div>
    );
};

export default UserDetails;
